import React, {useEffect} from 'react';
import {useFormContext} from "react-hook-form";
import {NotAnActiveClientInput} from "../../domain";
import {ModalDatePicker} from "../../form-components/ModalDatePicker";

type LastServiceDateInputProps = {
    sending: boolean
}

export function LastServiceDateInput({sending}: LastServiceDateInputProps) {
    const {
        setValue,
        watch
    } = useFormContext<NotAnActiveClientInput>();
    const wasClientAssignedToProvider = watch('wasClientAssignedToProvider') === 'YES';

    useEffect(() => {
        if (!wasClientAssignedToProvider) {
            setValue('lastServiceDate', '');
        }
    }, [wasClientAssignedToProvider, setValue])


    return (
        <>
            {
                wasClientAssignedToProvider &&
                <ModalDatePicker<NotAnActiveClientInput>
                    label={'Last Service Date'}
                    disabled={sending}
                    field={'lastServiceDate'}/>
            }
        </>
    );
}